import { ILanguage } from "src/app/services/api/type";

export const LANGUAGE = "EDU_STATISTICS_LANGUAGE";
export const language = (localStorage.getItem(LANGUAGE) || "uz") as keyof ILanguage;
